import { useState, useCallback, useEffect } from "react"

const EDGE_TYPES = [
  { value: "default", label: "Bezier (Curved)" },
  { value: "smoothstep", label: "Smooth Step" },
  { value: "step", label: "Step (Angular)" },
  { value: "straight", label: "Straight" },
]

const ARROW_OPTIONS = [
  { value: "end", label: "End only →" },
  { value: "start", label: "← Start only" },
  { value: "both", label: "← Both →" },
  { value: "none", label: "No arrows" },
]

export default function EdgeEditPanel({ edge, onUpdate, onDelete, onClose }) {
  const [label, setLabel] = useState(edge?.data?.label || "")
  const [edgeType, setEdgeType] = useState(edge?.data?.edgeType || "default")
  const [animated, setAnimated] = useState(edge?.data?.animated || false)
  const [arrowPosition, setArrowPosition] = useState(edge?.data?.arrowPosition || "end")

  // Sync state when edge changes
  useEffect(() => {
    if (edge) {
      setLabel(edge.data?.label || "")
      setEdgeType(edge.data?.edgeType || "default")
      setAnimated(edge.data?.animated || false)
      setArrowPosition(edge.data?.arrowPosition || "end")
    }
  }, [edge])

  const handleSave = useCallback(() => {
    onUpdate(edge.id, {
      data: {
        ...edge.data,
        label,
        edgeType,
        animated,
        arrowPosition,
      },
    })
  }, [edge, label, edgeType, animated, arrowPosition, onUpdate])

  const handleDelete = useCallback(() => {
    if (window.confirm("Delete this connector?")) {
      onDelete(edge.id)
    }
  }, [edge, onDelete])

  if (!edge) {
    return (
      <div className="edge-edit-panel empty">
        <p className="text-gray-500 text-sm">◎</p>
        <p className="text-gray-400 text-xs mt-1">Select a connector to edit</p>
      </div>
    )
  }

  return (
    <div className="edge-edit-panel">
      <div className="panel-header">
        <span className="panel-type">CONNECTOR</span>
        <button
          onClick={onClose}
          className="close-btn"
          title="Close"
        >
          ✕
        </button>
      </div>

      <div className="panel-body">
        <div className="form-group">
          <label htmlFor="edge-label">Label</label>
          <input
            id="edge-label"
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Optional label..."
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="edge-type">Line Type</label>
          <select
            id="edge-type"
            value={edgeType}
            onChange={(e) => setEdgeType(e.target.value)}
            className="form-select"
          >
            {EDGE_TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="arrow-position">Arrows</label>
          <select
            id="arrow-position"
            value={arrowPosition}
            onChange={(e) => setArrowPosition(e.target.value)}
            className="form-select"
          >
            {ARROW_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={animated}
              onChange={(e) => setAnimated(e.target.checked)}
            />
            <span>Animated</span>
          </label>
        </div>

        <div className="panel-actions">
          <button onClick={handleSave} className="btn-save">
            Apply Changes
          </button>
          <button onClick={handleDelete} className="btn-delete">
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}
